import { IPublicClientApplication } from "@azure/msal-browser"
import { getToken } from "Components/Functions";
import { api } from "./apiConfig"

export const OptionalExtraAPI = {
    update: async function (instance:IPublicClientApplication, bookingId: number, optionalExtraId: number, additionalDriver:boolean, added: boolean) {
        const apiCall = await api();
        const header = await getToken(instance);
        const response = await apiCall.request({
            url: "OptionalExtra/OptionalExtraUpdate",
            method: "POST",
            data: { booking_id: bookingId, optional_extra_id: optionalExtraId, additional_driver: additionalDriver, added },
            headers: { Authorization: header }
        })
        return response.data
    }
}